const userTypes = {
    GET_USERS:"GET_USERS",
    GET_USER:"GET_USER",
    AUTH:"AUTH",
    REGISTER:"REGISTER",
    CHECK_AUTH:"CHECK_AUTH",
    SIGNOUT:"SIGNOUT",
    UPDATE:"UPDATE",
    DELETE:"DELETE",
    FOLLOW:"FOLLOW",
    UNFOLLOW:"UNFOLLOW"
}
export default userTypes;